import { render, staticRenderFns } from "./BulkIssueModal.vue?vue&type=template&id=bff77d9a&scoped=true"
import script from "./BulkIssueModal.vue?vue&type=script&lang=js"
export * from "./BulkIssueModal.vue?vue&type=script&lang=js"
import style0 from "./BulkIssueModal.vue?vue&type=style&index=0&id=bff77d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff77d9a",
  null
  
)

export default component.exports